import gql from 'graphql-tag';

export default gql`
  mutation updateUserConversations($input: UpdateUserConversationsInput!) {
    updateUserConversations(input: $input) {
      __typename
      userId
      conversationId
      conversation {
        __typename
        id
        name
        caseId
        subject
        createdBy
        createdAt
        author {
          cognitoId
          username
          userData
        }
        keywords
        locale
        location
        sentiment
        intentsTriggered
        botSessionId
        lastQuestion
        status
        channel
        cms {
          conversationId
          isCore
          type
          id
        }
        transfers {
          conversationId
          createdAt
          userId
          nextUserId
          description
          user {
            cognitoId
            username
          }
          nextUser {
            cognitoId
            username
          }
        }
      }
      associated {
        __typename
        conversationId
        userId
        user {
          __typename
          cognitoId
          username
          registered
          avatarUrl
        }
        typing
        connected
        role
      }
    }
  }
`;
